import React from "react";
import { Button, Tag } from "antd";
import CustomPopover from "../../components/shared/custompopover/CustomPopover";
import viewIcon from "../../assets/icons/Eye.svg";
import editIcon from "../../assets/icons/Edit.svg";
import deleteIcon from "../../assets/icons/Delete.svg";
import LottieIcon from "../../components/shared/lottieIcon/LottieIcon";
import optionsIcon from "../../assets/icons/Options.svg";

const ROLE_STYLES = {
    employee: {
        color: "rgba(100, 37, 151, 1)",
        background: "rgba(249, 242, 255, 1)",
        borderColor: "rgba(175, 121, 219, 1)",
    },
    manager: {
        color: "rgba(145, 14, 17, 1)",
        background: "rgba(249, 243, 243, 1)",
        borderColor: "rgba(243, 163, 175, 1)",
    },
    admin_support: {
        color: "rgba(231, 72, 96, 1)",
        background: "rgba(254, 246, 247, 1)",
        borderColor: "rgba(211, 159, 160, 1)",
    },
    default: {
        color: "gray",
        background: "rgba(240, 240, 240, 1)",
        borderColor: "rgba(210, 210, 210, 1)",
    },
};

export const getUserColumns = ({
    isInactive,
    visiblePopover,
    setVisiblePopover,
    hoveredButton,
    setHoveredButton,
    handleViewUserClick,
    handleEditUser,
    handleOpenConfirmDeletePopup,
    isActive
}) => [
    {
        title: "Employee Id",
        key: "employeeId",
        dataIndex: "username",
        width: "15%",
    },
    {
        title: "Name",
        key: "name",
        dataIndex: "firstName",
        width: "20%",
        render: (_, record) => `${record.firstName} ${record.lastName}`,
    },
    {
        dataIndex: "manager",
        title: "Manager",
        key: "manager",
        width: "20%",
    },
    {
        dataIndex: "email",
        title: "E-Mail",
        key: "email",
        width: "20%",
    },
    {
        dataIndex: "role",
        title: "Role",
        key: "role",
        width: "15%",
        align: "center",
        render: (role) => {
            if (!role) return null;
            const roleKey = role.toLowerCase();
            const styles = ROLE_STYLES[roleKey] || ROLE_STYLES.default;
            const formattedRole = role.replace(/_/g, " ");
            
            return (
                <Tag
                    className="!px-4 !py-[10px] !rounded-[10px] !border !font-medium"
                    style={{
                        color: styles.color,
                        borderColor: styles.borderColor,
                        backgroundColor: styles.background,
                        width: "131px",
                        textAlign: "center",
                    }}
                >
                    {formattedRole}
                </Tag>
            );
        },
    },
    !isInactive && {
        title: "Actions",
        key: "actions",
        width: "10%",
        align: "center",
        ellipsis: true,
        render: (_, record) => {
            const popoverContent = (
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                    }}
                >
                    <Button
                        className="navbar-item"
                        onClick={() => {
                            handleViewUserClick(record?.userId);
                            setVisiblePopover(null);
                        }}
                        onMouseEnter={() => setHoveredButton("view")}
                        onMouseLeave={() => setHoveredButton(null)}
                        style={{ width: "11rem" }}
                    >
                        <span>View</span>
                        {hoveredButton === "view" ? (
                            <LottieIcon name="viewIcon" size={28} shouldPlay={true} />
                        ) : (
                            <img src={viewIcon} alt="view-icon" height={28} />
                        )}
                    </Button>

                    <Button
                        onClick={() => {
                            handleEditUser(record);
                            setVisiblePopover(null);
                        }}
                        style={{ width: "11rem" }}
                        className="navbar-item"
                        onMouseEnter={() => setHoveredButton("edit")}
                        onMouseLeave={() => setHoveredButton(null)}
                    >
                        <span>Edit</span>
                        {hoveredButton === "edit" ? (
                            <LottieIcon name="editIcon" size={28} shouldPlay={true} />
                        ) : (
                            <img src={editIcon} alt="Edit-icon" height={28} />
                        )}
                    </Button>

                    {isActive && (
                        <Button
                        onClick={() => {
                            setVisiblePopover(null);
                            handleOpenConfirmDeletePopup(record);
                        }}
                        style={{ width: "11rem" }}
                        className="navbar-item"
                        onMouseEnter={() => setHoveredButton("delete")}
                        onMouseLeave={() => setHoveredButton(null)}
                    >
                        <span>Delete</span>
                        {hoveredButton === "delete" ? (
                            <LottieIcon name="trashIcon" size={24} shouldPlay={true} />
                        ) : (
                            <img src={deleteIcon} alt="delete-icon" height={28} />
                        )}
                    </Button>)}
                </div>
            );

            return (
                <CustomPopover
                    content={popoverContent}
                    trigger="click"
                    className="admin-popover"
                    placement="bottomRight"
                    visible={visiblePopover === record.userId}
                    onVisibleChange={(visible) => {
                        setVisiblePopover(visible ? record.userId : null);
                        if (!visible) setHoveredButton(null);
                    }}
                    getPopupContainer={() => document.body} 
                >
                    <img src={optionsIcon} alt="options-icon" height={24} />
                </CustomPopover>
            );
        },
    },
].filter(Boolean);